import { createContext } from "react"
import type { Balance } from "./types"

export type BalancesContextType = {
  balances: Balance[]
  loading: boolean
  refreshBalances: () => void
}

export const BalancesContext = createContext<BalancesContextType>({
  balances: [],
  loading: false,
  refreshBalances: () => {},
})
